// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__PersonInfoForm-person-details__GIGZS .FormField{margin-top:var(--tri-space-400)}`, "",{"version":3,"sources":["webpack://./src/components/PersonInfoForm/styles.module.scss"],"names":[],"mappings":"AAII,0DACE,+BAAA","sourcesContent":["@use '../../styles//mediaQueries.module.scss';\n\n.PersonInfoForm {\n  &-person-details {\n    :global(.FormField) {\n      margin-top: var(--tri-space-400);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PersonInfoForm-person-details": `sputnik__PersonInfoForm-person-details__GIGZS`
};
export default ___CSS_LOADER_EXPORT___;
